import AppBadge from './AppBadge.vue';
import AppButton from './AppButton.vue';
import AppStatusBadge from './AppStatusBadge.vue';
import AppSpinner from './AppSpinner.vue';
import AppToggle from './AppToggle.vue';
import Avatar from './Avatar.vue';
import Combobox from './Combobox.vue';
import FavoriteButton from './FavoriteButton.vue';
import SelectBox from './SelectBox.vue';

export {
  AppBadge,
  AppButton,
  AppStatusBadge,
  AppSpinner,
  AppToggle,
  Avatar,
  Combobox,
  FavoriteButton,
  SelectBox,
};

export default {
  install(app) {
    app.component('AppBadge', AppBadge);
    app.component('AppButton', AppButton);
    app.component('AppStatusBadge', AppStatusBadge);
    app.component('AppSpinner', AppSpinner);
    app.component('AppToggle', AppToggle);
    app.component('Avatar', Avatar);
    app.component('Combobox', Combobox);
    app.component('FavoriteButton', FavoriteButton);
    app.component('SelectBox', SelectBox);
  },
};
